import React from 'react'

import InstagramPreviewMediaItems from './InstagramPreviewMediaItems'

import { renderTextWithEmoji } from '../../../helpers/other'

import LikeIcon from '../../../../assets/icons/instagram-preview/like.png'
import CommentIcon from '../../../../assets/icons/instagram-preview/comment.png'
import ShareIcon from '../../../../assets/icons/instagram-preview/share.png'
import SaveIcon from '../../../../assets/icons/instagram-preview/save.png'

import { POST_DESCRIPTION, PROFILE_NAME, PROFILE_PHOTO } from './fields'

import useStyles from './styles'

// instagram post preview should accept data using field naming from './fields.js'
const InstagramPostPreview = ({ post = {} }) => {
  const classes = useStyles()

  const { [PROFILE_PHOTO]: profilePhotoSrc, [PROFILE_NAME]: profileName, [POST_DESCRIPTION]: postDescription } = post

  return (
    <div className={classes.postPreview}>
      <div className={classes.postHeader}>
        <div className={classes.postProfilePhotoContainer}>
          <img className={classes.postProfilePhotoImage} src={profilePhotoSrc} alt="avatar" />
        </div>
        <p className={classes.postProfileName}>{profileName}</p>
      </div>
      <InstagramPreviewMediaItems post={post} />
      <div className={classes.postActionsContainer}>
        <div className={classes.postMainActionsIcons}>
          <img className={classes.postActionIcon} src={LikeIcon} alt="like" />
          <img className={classes.postActionIcon} src={CommentIcon} alt="comment" />
          <img className={classes.postActionIcon} src={ShareIcon} alt="share" />
        </div>
        <img className={classes.postActionIcon} src={SaveIcon} alt="save" />
      </div>
      <div className={classes.postFooter}>
        <p className={classes.postFooterText}>
          <span className={classes.postFooterProfileName}>
            <strong>{profileName}</strong>{' '}
          </span>
          {renderTextWithEmoji(postDescription)}
        </p>
      </div>
    </div>
  )
}

InstagramPostPreview.propTypes = {}

export default InstagramPostPreview
